import {
  BrowserModule,
  BrowserTransferStateModule,
} from '@angular/platform-browser';
import { NgModule, LOCALE_ID, Injectable } from '@angular/core';
import {
  IntersectionObserverHooks,
  LAZYLOAD_IMAGE_HOOKS,
} from 'ng-lazyload-image';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgPipesModule, StripTagsPipe } from 'ngx-pipes';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { DataService } from './data.service';
import { ListsService } from './lists.service';
import { AuthService } from './business/auth.service';
import { JwtInterceptor } from './jwt.interceptor';
import { environment } from 'src/environments/environment';
import { GALLERY_CONFIG } from '@ngx-gallery/core';
import localePl from '@angular/common/locales/pl';
import { registerLocaleData } from '@angular/common';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { Lightbox } from '@ngx-gallery/lightbox';
import { QuillModule } from 'ngx-quill';
import { SAVER, getSaver } from './_helpers/saver.provider';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { ServiceWorkerModule } from '@angular/service-worker';
import { InfoliniaModalComponent } from './business/infolinia-modal/infolinia-modal.component';
import { NgxMaskModule } from 'ngx-mask';
import {MapState} from './_state/map.state';
import {NgxsModule} from '@ngxs/store';
import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import { PrzerwaComponent } from './przerwa/przerwa.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { RegulationsComponent } from './regulations/regulations.component';

registerLocaleData(localePl, 'pl');

@Injectable()
export class LazyLoadImageHooks extends IntersectionObserverHooks {
  loadImage(props) {
    if (typeof props.imagePath === 'string') {
      return [props.imagePath];
    }
    const windowWidth = window.innerWidth;
    if (windowWidth < 270) {
      return [props.imagePath.xs];
    } else if (windowWidth < 380) {
      return [props.imagePath.sm];
    } else if (windowWidth < 570) {
      return [props.imagePath.md];
    }
    return [props.imagePath.lg];
  }
}

@NgModule({
  declarations: [AppComponent, InfoliniaModalComponent, PrzerwaComponent, PrivacyPolicyComponent, RegulationsComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    NgxCaptchaModule,
    BrowserAnimationsModule,
    NgPipesModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxsModule.forRoot([
      MapState
    ], {
      developmentMode: !environment.production
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: environment.production
    }),
    BsDropdownModule.forRoot(),
    BrowserTransferStateModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    AppRoutingModule,
    NgxMaskModule.forRoot(),
    NgxSmartModalModule.forRoot(),
    QuillModule.forRoot({
      customOptions: [
        {
          import: 'formats/font',
          whitelist: [
            'Arial',
            'bodoni-urw',
            'Courier',
            'Garamond',
            'Roboto',
            'Tahoma',
            'Times New Roman',
            'Verdana',
          ],
        },
      ],
    }),
    GoogleTagManagerModule.forRoot({
      id: environment.ga,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
  ],
  providers: [
    StripTagsPipe,
    DataService,
    ListsService,
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadImageHooks },
    { provide: LOCALE_ID, useValue: 'pl' },
    { provide: SAVER, useFactory: getSaver },
    {
      provide: GALLERY_CONFIG,
      useValue: {
        loop: false,
        loadingMode: 'indeterminate',
        loadingStrategy: 'preload',
      },
    },
    Lightbox,
    { provide: Lightbox, useValue: {} },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
